export default __webpack_public_path__ + "static/S-2000i100B-28388c44a7b57bc30b1471fd80afde61.jpg";